/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputDeleteServiceDocumentStructure } from '../models';
// @ts-ignore
import type { ResponseGetCountCitizensAvailableServices } from '../models';
// @ts-ignore
import type { ResponseScheduleCitizensForAvailableServices } from '../models';
// @ts-ignore
import type { Service } from '../models';
// @ts-ignore
import type { ServiceDocumentStructure } from '../models';
/**
 * AdminServiceApi - axios parameter creator
 * @export
 */
export const AdminServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Service\"] 
         * @summary Get available service
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServices: async (filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/service/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"Service\"] 
         * @summary Create a new service
         * @param {Service} [service] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService: async (service?: Service, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/service/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(service, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"ServiceDocumentStructure\"] 
         * @summary Create a new service document structure | Permission required: [\"create\", \"ServiceDocumentStructure\"]
         * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceDocumentStructure: async (serviceDocumentStructure?: ServiceDocumentStructure, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/service/serviceDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceDocumentStructure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"delete\", \"Service\"] 
         * @summary Delete a single service
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteServiceById', 'id', id)
            const localVarPath = `/admin/service/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"delete\", \"ServiceDocumentStructure\"] 
         * @summary delete a service | Permission required: [\"delete\", \"ServiceDocumentStructure\"]
         * @param {InputDeleteServiceDocumentStructure} [inputDeleteServiceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceDocumentStructure: async (inputDeleteServiceDocumentStructure?: InputDeleteServiceDocumentStructure, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/service/serviceDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputDeleteServiceDocumentStructure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"Service\"] 
         * @summary Edit a service
         * @param {Service} [service] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editService: async (service?: Service, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/service/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(service, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceDocumentStructure\"] 
         * @summary Edit a service | Permission required: [\"update\", \"ServiceDocumentStructure\"]
         * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServiceDocumentStructure: async (serviceDocumentStructure?: ServiceDocumentStructure, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/service/serviceDocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serviceDocumentStructure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get count citizens available services
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountCitizensAvailableServices: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCountCitizensAvailableServices', 'id', id)
            const localVarPath = `/admin/service/{id}/send-notification`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"Service\"] 
         * @summary Get a single service
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getServiceById', 'id', id)
            const localVarPath = `/admin/service/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Schedule citizens for available services
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleCitizensForAvailableServices: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scheduleCitizensForAvailableServices', 'id', id)
            const localVarPath = `/admin/service/{id}/send-notification`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminServiceApi - functional programming interface
 * @export
 */
export const AdminServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminServiceApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Service\"] 
         * @summary Get available service
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allServices(filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Service>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allServices(filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.allServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"Service\"] 
         * @summary Create a new service
         * @param {Service} [service] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createService(service?: Service, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Service>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createService(service, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.createService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"ServiceDocumentStructure\"] 
         * @summary Create a new service document structure | Permission required: [\"create\", \"ServiceDocumentStructure\"]
         * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceDocumentStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServiceDocumentStructure(serviceDocumentStructure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.createServiceDocumentStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"delete\", \"Service\"] 
         * @summary Delete a single service
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteServiceById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Service>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteServiceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.deleteServiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"delete\", \"ServiceDocumentStructure\"] 
         * @summary delete a service | Permission required: [\"delete\", \"ServiceDocumentStructure\"]
         * @param {InputDeleteServiceDocumentStructure} [inputDeleteServiceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure?: InputDeleteServiceDocumentStructure, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceDocumentStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.deleteServiceDocumentStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"Service\"] 
         * @summary Edit a service
         * @param {Service} [service] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editService(service?: Service, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Service>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editService(service, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.editService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceDocumentStructure\"] 
         * @summary Edit a service | Permission required: [\"update\", \"ServiceDocumentStructure\"]
         * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceDocumentStructure>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editServiceDocumentStructure(serviceDocumentStructure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.editServiceDocumentStructure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get count citizens available services
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountCitizensAvailableServices(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseGetCountCitizensAvailableServices>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountCitizensAvailableServices(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.getCountCitizensAvailableServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"Service\"] 
         * @summary Get a single service
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServiceById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Service>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.getServiceById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Schedule citizens for available services
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleCitizensForAvailableServices(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseScheduleCitizensForAvailableServices>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleCitizensForAvailableServices(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceApi.scheduleCitizensForAvailableServices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminServiceApi - factory interface
 * @export
 */
export const AdminServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminServiceApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Service\"] 
         * @summary Get available service
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allServices(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Service>> {
            return localVarFp.allServices(filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"Service\"] 
         * @summary Create a new service
         * @param {Service} [service] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createService(service?: Service, options?: RawAxiosRequestConfig): AxiosPromise<Service> {
            return localVarFp.createService(service, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"ServiceDocumentStructure\"] 
         * @summary Create a new service document structure | Permission required: [\"create\", \"ServiceDocumentStructure\"]
         * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<ServiceDocumentStructure> {
            return localVarFp.createServiceDocumentStructure(serviceDocumentStructure, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"delete\", \"Service\"] 
         * @summary Delete a single service
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Service> {
            return localVarFp.deleteServiceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"delete\", \"ServiceDocumentStructure\"] 
         * @summary delete a service | Permission required: [\"delete\", \"ServiceDocumentStructure\"]
         * @param {InputDeleteServiceDocumentStructure} [inputDeleteServiceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure?: InputDeleteServiceDocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<ServiceDocumentStructure> {
            return localVarFp.deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Service\"] 
         * @summary Edit a service
         * @param {Service} [service] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editService(service?: Service, options?: RawAxiosRequestConfig): AxiosPromise<Service> {
            return localVarFp.editService(service, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"ServiceDocumentStructure\"] 
         * @summary Edit a service | Permission required: [\"update\", \"ServiceDocumentStructure\"]
         * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<ServiceDocumentStructure> {
            return localVarFp.editServiceDocumentStructure(serviceDocumentStructure, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get count citizens available services
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountCitizensAvailableServices(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetCountCitizensAvailableServices> {
            return localVarFp.getCountCitizensAvailableServices(id, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"Service\"] 
         * @summary Get a single service
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServiceById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Service> {
            return localVarFp.getServiceById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Schedule citizens for available services
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleCitizensForAvailableServices(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseScheduleCitizensForAvailableServices> {
            return localVarFp.scheduleCitizensForAvailableServices(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminServiceApi - interface
 * @export
 * @interface AdminServiceApi
 */
export interface AdminServiceApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"Service\"] 
     * @summary Get available service
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    allServices(filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Service>>;

    /**
     *  **Permission required**: [\"create\", \"Service\"] 
     * @summary Create a new service
     * @param {Service} [service] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    createService(service?: Service, options?: RawAxiosRequestConfig): AxiosPromise<Service>;

    /**
     *  **Permission required**: [\"create\", \"ServiceDocumentStructure\"] 
     * @summary Create a new service document structure | Permission required: [\"create\", \"ServiceDocumentStructure\"]
     * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    createServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<ServiceDocumentStructure>;

    /**
     *  **Permission required**: [\"delete\", \"Service\"] 
     * @summary Delete a single service
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    deleteServiceById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Service>;

    /**
     *  **Permission required**: [\"delete\", \"ServiceDocumentStructure\"] 
     * @summary delete a service | Permission required: [\"delete\", \"ServiceDocumentStructure\"]
     * @param {InputDeleteServiceDocumentStructure} [inputDeleteServiceDocumentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure?: InputDeleteServiceDocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<ServiceDocumentStructure>;

    /**
     *  **Permission required**: [\"update\", \"Service\"] 
     * @summary Edit a service
     * @param {Service} [service] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    editService(service?: Service, options?: RawAxiosRequestConfig): AxiosPromise<Service>;

    /**
     *  **Permission required**: [\"update\", \"ServiceDocumentStructure\"] 
     * @summary Edit a service | Permission required: [\"update\", \"ServiceDocumentStructure\"]
     * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    editServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig): AxiosPromise<ServiceDocumentStructure>;

    /**
     * 
     * @summary Get count citizens available services
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    getCountCitizensAvailableServices(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseGetCountCitizensAvailableServices>;

    /**
     *  **Permission required**: [\"readOne\", \"Service\"] 
     * @summary Get a single service
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    getServiceById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Service>;

    /**
     * 
     * @summary Schedule citizens for available services
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApiInterface
     */
    scheduleCitizensForAvailableServices(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseScheduleCitizensForAvailableServices>;

}

/**
 * AdminServiceApi - object-oriented interface
 * @export
 * @class AdminServiceApi
 * @extends {BaseAPI}
 */
export class AdminServiceApi extends BaseAPI implements AdminServiceApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"Service\"] 
     * @summary Get available service
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public allServices(filter?: string, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).allServices(filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"Service\"] 
     * @summary Create a new service
     * @param {Service} [service] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public createService(service?: Service, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).createService(service, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"ServiceDocumentStructure\"] 
     * @summary Create a new service document structure | Permission required: [\"create\", \"ServiceDocumentStructure\"]
     * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public createServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).createServiceDocumentStructure(serviceDocumentStructure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"delete\", \"Service\"] 
     * @summary Delete a single service
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public deleteServiceById(id: number, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).deleteServiceById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"delete\", \"ServiceDocumentStructure\"] 
     * @summary delete a service | Permission required: [\"delete\", \"ServiceDocumentStructure\"]
     * @param {InputDeleteServiceDocumentStructure} [inputDeleteServiceDocumentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure?: InputDeleteServiceDocumentStructure, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).deleteServiceDocumentStructure(inputDeleteServiceDocumentStructure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"Service\"] 
     * @summary Edit a service
     * @param {Service} [service] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public editService(service?: Service, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).editService(service, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"ServiceDocumentStructure\"] 
     * @summary Edit a service | Permission required: [\"update\", \"ServiceDocumentStructure\"]
     * @param {ServiceDocumentStructure} [serviceDocumentStructure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public editServiceDocumentStructure(serviceDocumentStructure?: ServiceDocumentStructure, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).editServiceDocumentStructure(serviceDocumentStructure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get count citizens available services
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public getCountCitizensAvailableServices(id: number, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).getCountCitizensAvailableServices(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"Service\"] 
     * @summary Get a single service
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public getServiceById(id: number, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).getServiceById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Schedule citizens for available services
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceApi
     */
    public scheduleCitizensForAvailableServices(id: number, options?: RawAxiosRequestConfig) {
        return AdminServiceApiFp(this.configuration).scheduleCitizensForAvailableServices(id, options).then((request) => request(this.axios, this.basePath));
    }
}

